import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from '@reenstudio/app/core/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="d-none d-lg-flex align-items-center" style="width: 220px;">
      <a [routerLink]="['/']" class="d-flex">
        <img
          src="./assets/images/logos/logo-reen-white.png"
          class="align-middle m-2"
          alt="logo"
          width="200"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
